// extracted by mini-css-extract-plugin
module.exports = {"StatsArea":"StatsArea_StatsArea__1_elt"};